export const carrierImage = require('./carrierImage.png?webp');
export const carriersBgImage = require('./carriers-bg-hero.png?webp');
